<template>
  <section id="what-is-deenly" class="py-24 bg-[#fafbfc] relative overflow-hidden">
    <div
      class="absolute -top-20 right-0 w-[500px] h-[500px] bg-[#ecd79f]/15 blur-[120px] rounded-full pointer-events-none"
    ></div>

    <div class="max-w-7xl mx-auto px-6 relative z-10">
      <div v-reveal class="max-w-3xl mb-14">
        <div
          class="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#1c4848]/5 border border-[#1c4848]/10 mb-6"
        >
          <span class="w-2 h-2 rounded-full bg-[#ecd79f]"></span>
          <span class="text-xs font-semibold text-[#1c4848] tracking-wide uppercase">
            {{ content.badge }}
          </span>
        </div>
        <h2 class="text-4xl lg:text-5xl font-serif text-[#1c4848] font-semibold mb-6 tracking-tight">
          {{ content.title }}
        </h2>
        <p class="text-lg lg:text-xl text-[#1c4848]/70 font-medium leading-relaxed">
          {{ content.audience }}
        </p>
      </div>

      <ul class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        <li
          v-for="(feature, i) in content.features"
          :key="feature.title"
          v-reveal="{ delayMs: (i % 3) * 60 }"
          class="bg-white rounded-3xl p-6 border border-[#1c4848]/5 flex gap-4 hover:shadow-lg transition-shadow duration-300"
        >
          <div
            class="w-11 h-11 rounded-2xl bg-[#ecd79f]/25 text-[#1c4848] flex items-center justify-center shrink-0"
          >
            <iconify-icon :icon="feature.icon" class="text-2xl"></iconify-icon>
          </div>
          <div class="min-w-0">
            <h3 class="text-base font-semibold text-[#1c4848] mb-1">{{ feature.title }}</h3>
            <p class="text-sm text-[#1c4848]/60 font-medium leading-relaxed">{{ feature.body }}</p>
          </div>
        </li>
      </ul>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { siteContent } from '@/seo/siteContent.js';

const { locale } = useI18n();
const content = computed(() => (siteContent[locale.value] ?? siteContent.en).whatIs);
</script>
